<template>
    <div class="survey-note-list-item">

        <b-card no-body>
            <b-card-header class="survey-note-list-item__header">
                <b-row>
                    <b-col cols="12" class="mb-2">
                        <div class="survey-note-list-item__timestamp float-right">
                            <timestamp :date="surveyNote.drafted"></timestamp>
                        </div>
                        <h6>
                            {{ surveyNote.practitioner_fullname }}
                            <br/>
                            ({{ $i18n.getNoteTypeLabel(surveyNote.note_type) }})
                        </h6>
                    </b-col>
                    <b-col cols="6" class="">
                        <b-badge variant="warning" v-if="noteIsDraft">
                            {{ $i18n.gt('BADGE_DRAFT') }}
                        </b-badge>
                        <b-badge variant="danger" v-if="needsSuperbill && userIsPractitioner">
                            {{ $i18n.gt('BADGE_NO_BILL') }}
                        </b-badge>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-btn variant="primary" size="sm btn-edit btn-icon"
                               v-if="!surveyNote.locked"
                               :to="`/participant/editNote/participantId/${surveyNote.participant_id}/id/${surveyNote.id}`">
                            <shs-icon name="pencil"></shs-icon>
                        </b-btn>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <survey-note-view-patient :survey-note="surveyNote"></survey-note-view-patient>
            </b-card-body>
            <b-card-footer v-if="userIsPractitioner && $auth.canManagePracticeBilling()">
                <div class="float-right">
                    <superbill-form-modal :survey-note="surveyNote"></superbill-form-modal>
                </div>
            </b-card-footer>
        </b-card>

    </div>
</template>

<script>
import SurveyNote from "@/providers/SurveyNote"

/**
 * Displays an individual SurveyNote within a SurveyNoteList
 */
export default {
    name: 'SurveyNoteListItem',
    props: {
        surveyNote: Object
    },
    computed: {
        userIsPractitioner() {
            return this.$user.practitionerId() != null && !this.$user.isMaskingPractitioner()
        },
        noteIsDraft() {
            return SurveyNote.isDraft(this.surveyNote)
        },
        needsSuperbill() {
            return SurveyNote.hasNoBill(this.surveyNote)
        }
    }
}
</script>

<style lang="scss">

.survey-note-list-item__header {
    background-color: #fafafa !important;

    h6 {
        margin: 0;
        font-weight: bold;
    }
}

.survey-note-list-item__timestamp {
    color: #ccc;
    font-size: .9em;
}
</style>
